import axios from "axios";
import handleError from "../../utils/errorHandling";

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    // Some endpoints (e.g. campaigns list) can be slow; avoid aborting too aggressively.
    timeout: 60000,
    headers: {
        "Content-Type": "application/json",
    },
});

// Request Interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("authToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor
axiosInstance.interceptors.response.use(
    (response) => response.data,
    (error) => {
        // Use centralized error handling
        const handledError = handleError(error);
        return Promise.reject(handledError);
    }
);

// Deduplicate concurrent identical GET requests — all callers share one in-flight promise.
const inFlight = new Map();
const _get = axiosInstance.get.bind(axiosInstance);
axiosInstance.get = (url, config = {}) => {
    const key = url + JSON.stringify(config.params || {});
    if (inFlight.has(key)) return inFlight.get(key);
    const promise = _get(url, config).finally(() => inFlight.delete(key));
    inFlight.set(key, promise);
    return promise;
};

export default axiosInstance;
